import app from 'flarum/forum/app';
app.initializers.add('val-ui-tag-last-post-author', () => {
  const STYLE_ID = 'val-ui-tag-last-post-author-style';
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
.TagsPage .TagTile-lastPostedDiscussion {
    min-height: 42px;
    line-height: 1.3;
}

.TagsPage .val-tag-last-post-meta {
    display: block;
    margin-bottom: 2px;
    color: var(--muted-color);
    font-size: 11px;
    line-height: 1.25;
}

.TagsPage .val-tag-last-post-author {
    font-weight: 700;
}

.TagsPage .TagTile-lastPostedDiscussion-title {
    display: inline;
    font-weight: 600;
}

.TagsPage .TagTile-lastPostedDiscussion-title::after {
    content: " ";
}
`;
    document.head.appendChild(style);
  }
  function tagFromHref(href) {
    let url;
    try {
      url = new URL(href, location.href);
    } catch (_) {
      return null;
    }
    const match = url.pathname.match(/^\/t\/([^/]+)\/?$/);
    if (!match) return null;
    let slug = match[1];
    try {
      slug = decodeURIComponent(slug);
    } catch (_) {}
    return app.store.all('tags').find(tag => {
      if (!tag || typeof tag.slug !== 'function') return false;
      return String(tag.slug()) === String(slug);
    }) || null;
  }
  function renderAuthors() {
    const page = document.querySelector('.TagsPage');
    if (!page) return;
    page.querySelectorAll('.TagTile').forEach(tile => {
      const info = tile.querySelector('.TagTile-info[href]');
      const last = tile.querySelector('a.TagTile-lastPostedDiscussion');
      if (!info) return;
      if (!last) {
        if (!tile.querySelector('.TagTile-lastPostedDiscussion')) {
          const empty = document.createElement('div');
          empty.className = 'TagTile-lastPostedDiscussion val-tag-last-post-empty';
          empty.textContent = 'Dernier message :';
          tile.appendChild(empty);
        }
        return;
      }
      const tag = tagFromHref(info.href);
      if (!tag || typeof tag.attribute !== 'function') return;
      const name = String(tag.attribute('valLastPostedUserName') || '').trim();
      if (!name) return;
      const color = String(tag.attribute('valLastPostedUserColor') || '').trim();
      const title = last.querySelector('.TagTile-lastPostedDiscussion-title');
      if (!title) return;
      let meta = last.querySelector('.val-tag-last-post-meta');
      if (!meta) {
        meta = document.createElement('span');
        meta.className = 'val-tag-last-post-meta';
        const label = document.createTextNode('Dernier message : ');
        const author = document.createElement('span');
        author.className = 'val-tag-last-post-author';
        meta.appendChild(label);
        meta.appendChild(author);
        last.insertBefore(meta, title);
      }
      const author = meta.querySelector('.val-tag-last-post-author');
      if (author) {
        author.textContent = name;
        author.style.color = color || '';
      }
    });
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      renderAuthors();
    });
  }
  const startObserver = () => {
    const root = document.querySelector('#app') || document.body;
    if (!root) return;
    const observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true
    });
    schedule();
  };
  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver, {
      once: true
    });
  }
});